import debounce from 'lodash.debounce';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useAppDispatch, useAppState } from '@/store';
import { getStores, storesSelector } from '../feature';

export const useStoresAutocomplete = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { storeList } = useAppState(storesSelector);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getStores({}));
  }, []);

  const handleSearch = useCallback(
    debounce(async (search) => {
      const value = search?.trim();
      if (!value) return;
      try {
        setIsLoading(true);

        return await dispatch(
          getStores({
            title: value,
          }),
        ).unwrap();
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    }, 500),
    [],
  );

  useEffect(() => {
    return () => {
      handleSearch.cancel();
    };
  }, []);

  return useMemo(
    () => ({
      storeList,
      options: storeList?.map((item) => ({
        label: item?.title ?? '',
        value: item?.id,
      })),
      isLoading,
      onSearch: handleSearch,
    }),
    [storeList, isLoading],
  );
};
